module.exports = __webpack_public_path__ + "img/steam-turbine-H.436645b0.png";